// extracted by mini-css-extract-plugin
export var deliveryRow = "_ko-a";
export var fixedHeight = "_ko-4";
export var freightLogo = "_ko-9";
export var fullWidth = "_ko-3";
export var priceColumn = "_ko-5";
export var radioSelected = "_ko-7";
export var radioUnselected = "_ko-6";
export var selectedOption = "_ko-2";
export var selectedOptionContainer = "_ko-1";
export var selection = "_ko-0";
export var tallSkeletonText = "_ko-8";